var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('StatusCircleIcon',{attrs:{"statusClass":_vm.statusClass,"size":_vm.statusSize}}),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }